import { createContext, useEffect, useReducer } from "react";

const INITIAL_STATE = {
  admin: JSON.parse(localStorage.getItem("authUser")) || null,
  loading: false,
  error: null,
};

export const AuthContext = createContext(INITIAL_STATE);

const AuthReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN_START":
      return {
        ...state, 
        loading: true,
        error: null,
      };

    case "LOGIN_SUCCESS":
      return {
        admin: action.payload,
        loading: false,
        error: null,
      };

    case "LOGIN_FAILURE":
      return {
        admin: null,
        loading: false,
        error: action.payload,
      };

    case "LOGOUT":
      localStorage.removeItem("authUser");
      return {
        admin: null,
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE);

  useEffect(() => {
    if (state.admin) {
      localStorage.setItem("authUser", JSON.stringify(state.admin));
    } else {
      localStorage.removeItem("authUser");
    }
  }, [state.admin]);

  return (
    <AuthContext.Provider
      value={{
        admin: state.admin,
        loading: state.loading,
        error: state.error,
        dispatch,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
